'use strict';
const	React					= require('react')
		, ComponentFactory		= require('factories/Component')
		, PopupLoginSidebar		= require('modules/components/login/popup/_sidebar')
		, BasicPopup		= require('modules/components/popup/basic')
		, ComponentConfig		= require('./config')
		;

module.exports = ComponentFactory.create(Object.assign({},ComponentConfig,{
	displayName : 'LoginPopup',
	render : function(Components){
		return (
			<div className="wrapper login-popup-desktop">
				<div className="row row-no-gutter flex">
					{(() => {
						if(this.state.partial == 'signup.basic') {
							return( <BasicPopup 
								title={this.translator.toText( 'email_not_registered' )}
								content={`${this.translator.toText( 'email_not_registered_desc' )}<strong>${this.props.email}</strong>`}
								closePopup={this.showIndex.bind(this)}
								targetUrl={`/register?email=${encodeURIComponent(this.props.email)}&redirect_uri=${window.location.pathname}`}
								leftButton={this.translator.toText( 'change_email_label' )}
								rightButton={this.translator.toText( 'link_register' )}
							/>)
						}
					})()}
					{this.state.component}
					<PopupLoginSidebar />
				</div>
			</div>
		)
	}
}))



// WEBPACK FOOTER //
// resources/modules/components/popup/login/component.jsx